import { timeAgo } from "@/lib/constants";
import {
  FilePlus2, RefreshCw, MessageSquare, ArrowRightLeft, CheckCircle2,
  XCircle, Send, UserPlus, FileText,
} from "lucide-react";

const ICONS = {
  created: FilePlus2, status_change: RefreshCw, stage_change: ArrowRightLeft, note: MessageSquare,
  call: MessageSquare, meeting: MessageSquare, assigned: UserPlus, converted: ArrowRightLeft,
  submitted: Send, approved: CheckCircle2, rejected: XCircle, sent: Send, accepted: CheckCircle2,
  revised: FileText,
};

export function ActivityTimeline({ activities = [] }) {
  if (!activities.length) return <p className="text-sm text-slate-400 py-6 text-center">No activity yet.</p>;
  return (
    <div className="space-y-0" data-testid="activity-timeline">
      {activities.map((a, i) => {
        const Icon = ICONS[a.action_type] || MessageSquare;
        return (
          <div key={a.id || i} className="flex gap-3 pb-4 relative">
            {i !== activities.length - 1 && <span className="absolute left-[15px] top-8 bottom-0 w-px bg-slate-200" />}
            <span className="h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 z-10">
              <Icon className="h-4 w-4 text-slate-500" />
            </span>
            <div className="min-w-0 flex-1 pt-1">
              <p className="text-sm text-slate-800">{a.description}</p>
              <p className="text-xs text-slate-400 mt-0.5">{a.performed_by_name} · {timeAgo(a.created_at)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
